import { Component, OnInit, Injector } from '@angular/core';
import { DataGridTemplate, GridButton } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { Subject } from 'rxjs';
import * as CtwrService from '../../../ctwr.service';
import { BaseService } from '../../../../mesc/mesc.service';
import { AuthenticationService } from '../../../../../auth.service';
import { FilterableService } from '../../../../mesc/filterable-service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'app-parts',
  templateUrl: './parts.component.html',
  styleUrls: ['./parts.component.scss']
})

export class PartsComponent extends DataGridTemplate implements OnInit {
  private module: any;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly programNotificationUsers: FilterableService = new FilterableService();
  private readonly designerService: FilterableService = new FilterableService();
  private readonly tmService: FilterableService = new FilterableService();
  private readonly pte2Service: FilterableService = new FilterableService();
  private formBuilder: FormBuilder;
  private partsService: CtwrService.CtwrPartService;
  private service: BaseService;
  private programService: CtwrService.CtwrProgramService;
  private designPhaseService: CtwrService.CtwrDesignPhaseService;
  private locationService: CtwrService.CtwrLocationService;
  private partTypeService: CtwrService.CtwrPartTypeService;
  private processService: CtwrService.CtwrProcessService;
  private partFamilyService: CtwrService.CtwrPartFamilyService;
  private authService: AuthenticationService;
  private alertDialog: CgpAlertDialogService;
  pte1Service: FilterableService = new FilterableService();
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  isShowPartOwnership: boolean;
  availableParts: FilterableService = new FilterableService();

  constructor(private readonly injector: Injector) {
    super();
  }


  /**
   * 
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  /**
   * 
   */
  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.reorderable = true;
    this.resizable = true;
    this.filterable = 'menu';
    this.controls.configure = true;
    this.formDialog.largeForm = true;
    this.formDialog.setHeight(640);
    this.editForm = this.getEditForm();
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };
    this.formDialog.footerLabel = { flag: 'info', value: '*If PTE2 is not selected then the user selected for PTE1 will also be designated as PTE2.' };
    this.gridState.sort = [{ dir: 'asc', field: 'PartNumber' }];
    this.initializeServices();
    this.registerComponents();
    this.controls.customToolBarButtons = this.customToolBarButtons;
  }


  /**
   * 
   */
  private initializeServices() {
    this.partsService = this.injector.get(CtwrService.CtwrPartService);
    this.service = this.injector.get(BaseService);
    this.programService = this.injector.get(CtwrService.CtwrProgramService);
    this.designPhaseService = this.injector.get(CtwrService.CtwrDesignPhaseService);
    this.locationService = this.injector.get(CtwrService.CtwrLocationService);
    this.partTypeService = this.injector.get(CtwrService.CtwrPartTypeService);
    this.processService = this.injector.get(CtwrService.CtwrProcessService);
    this.partFamilyService = this.injector.get(CtwrService.CtwrPartFamilyService);
    this.authService = this.injector.get(AuthenticationService);
    this.alertDialog = this.injector.get(CgpAlertDialogService);
    this.programService.read();
    this.designPhaseService.read();
    this.locationService.read();
    this.partTypeService.read();
    this.processService.read();
    this.formDialog.initilize("Part", this.editForm, this.getFormTemplate());
  }

  /**
   * 
   */
  private registerComponents() {
    this.authService.getActiveModule()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(mod => {
        this.module = mod;
        if (mod) this.updatePartUsers();
      });
  }


  /**
   * 
   */
  private getEditForm(): FormGroup {
    this.formBuilder = this.injector.get(FormBuilder);
    return this.formBuilder.group({
      Id: [],
      PartNumber: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ProgramId: ['', Validators.required],
      DesignPhaseId: ['', Validators.required],
      LocationId: ['', Validators.required],
      PartTypeId: ['', Validators.required],
      ProcessId: ['', Validators.required],
      PartFamilyId: [''],
      PTE1: ['', Validators.required],
      PTE2: [''],
      TMUserId: ['', Validators.required],
      DesignerUserId: ['', Validators.required],
      ProgramNotificationUsers: [''],
    });
  }


  /**
   * 
   */
  private updatePartUsers() {
    this.service.read(`common/User/role/${this.module.Id}`)
      .then(data => {
        data.map(u => u.cn = `${u.FirstName} ${u.LastName}`);
        this.tmService.next(data.filter(x => x.Roles.some(r => r === 'TM')));
        this.pte1Service.next(data.filter(x => x.Roles.some(r => r === 'PTE')));
        this.designerService.next(data.filter(x => x.Roles.some(r => r === 'DES')));
        this.programNotificationUsers.next(data.map(x => {
          const _roles = x.Roles.length > 0 ? x.Roles : '*No assigned roles*';
          x.PnuName = `${x.FirstName} ${x.LastName} [${_roles}]`;
          return x;
        }));
      });
  }


  /**
   * 
   * @param opts 
   */
  read(opts: any): Promise<any> {
    return opts.force ?
      this.partsService.read('')
        .then(x => {
          this.availableParts.next(x);
          return x;
        }) :
      Promise.resolve(this.partsService.value);
  }


  /**
   * 
   * @param parentEditDataItem 
   */
  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
    this.editForm.get('PartNumber').enable();
    this.editForm.get('PartFamilyId').disable();
    this.editForm.get('PTE2').disable();
  }


  /**
   * 
   * @param dataItem 
   */
  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.partsService.read(`/${dataItem.Id}`)
      .then(x => {
        this.formDialog.next(x);
        this.changePartFamily();
        this.handlePTE1Change();
      })
    this.editForm.get('PartNumber').disable();

    this.editForm.get('ProcessId').valid ?
      this.editForm.get('PartFamilyId').enable() :
      this.editForm.get('PartFamilyId').disable()

    if (this.editForm.get('PTE1').valid) {
      this.editForm.get('PTE2').enable();
      this.pte2Service.next([])
    }
    else {
      this.editForm.get('PTE2').disable();
    }
  }


  /**
   * 
   * @param dataItem 
   * @param isNew 
   */
  save(dataItem: any, isNew: boolean): Promise<any> {
    return isNew ? this.partsService.save(dataItem, isNew, '', false)
      .catch(e => this.alertDialog.showAlertDialog({
        title: "Error",
        message: e && e.message ? e.message : e,
        alert: 'danger',
        closeLabel: 'Close',
      })) : this.partsService.save(dataItem, isNew, `/${dataItem.Id}`, false);
  }


  /**
   * 
   * @param dataItem 
   */
  delete(dataItem: any): Promise<any> {
    return this.partsService.remove(`/${dataItem.Id}`, false);
  }


  /**
   * 
   */
  private readonly changePartFamily = () => {
    const form = this.editForm;
    if (form.get('ProcessId').valid) {
      const processId = form.get('ProcessId').value;

      this.partFamilyService.read(`/GetByProcessId?processId=${processId}`)
        .then(x => {
          form.get('PartFamilyId').enable();
        })
    }
    else {
      form.get('PartFamilyId').setValue(undefined);
      this.partFamilyService.next([]);
      form.get('PartFamilyId').disable();
    }
  }


  /**
   * 
   */
  private readonly handlePTE1Change = () => {
    const form = this.editForm;
    if (form.get('PTE1').valid) {
      form.get('PTE2').enable();
      const pte1 = form.get('PTE1').value;
      this.pte2Service.next(this.pte1Service.value.filter(p => p.Id !== pte1));
    }
    else {
      form.get('PTE2').setValue(undefined);
      this.pte2Service.next([]);
      form.get('PTE2').disable();
    }
  }


  /**
   * 
   */
  onTransfer() {
    this.refresh();
  }


  /**
   * 
   */
  private getFormTemplate() {
    const formControls = [
      {
        type: 'text',
        title: 'Part Number',
        name: 'PartNumber',
        placeholder: 'Enter a Part Number',
        stretch: true,
        invalidText: 'Input must be between 1 and 65 characters.'
      },
      {
        type: 'combobox',
        title: 'Program',
        name: 'ProgramId',
        textField: 'Name',
        valueField: 'Id',
        service: this.programService,
      },
      {
        type: 'combobox',
        title: 'Design Phase',
        name: 'DesignPhaseId',
        textField: 'Name',
        valueField: 'Id',
        service: this.designPhaseService,
      },
      {
        type: 'combobox',
        title: 'Location',
        name: 'LocationId',
        textField: 'Name',
        valueField: 'Id',
        service: this.locationService,
      },
      {
        type: 'combobox',
        title: 'Part Type',
        name: 'PartTypeId',
        textField: 'Name',
        valueField: 'Id',
        service: this.partTypeService,
      },
      {
        type: 'combobox',
        title: 'Process',
        name: 'ProcessId',
        textField: 'Name',
        valueField: 'Id',
        service: this.processService,
        onChange: this.changePartFamily,
      },
      {
        type: 'combobox',
        title: 'PartFamily',
        name: 'PartFamilyId',
        textField: 'Name',
        valueField: 'Id',
        service: this.partFamilyService,
      },
      {
        type: 'combobox',
        title: 'PTE1',
        name: 'PTE1',
        textField: 'cn',
        valueField: 'Id',
        service: this.pte1Service,
        onChange: this.handlePTE1Change,
      },
      {
        type: 'combobox',
        title: 'Technical Manager',
        name: 'TMUserId',
        textField: 'cn',
        valueField: 'Id',
        service: this.tmService,
      },
      {
        type: 'combobox',
        title: 'PTE2',
        name: 'PTE2',
        textField: 'cn',
        valueField: 'Id',
        service: this.pte2Service,
      },
      {
        type: 'combobox',
        title: 'Designer',
        name: 'DesignerUserId',
        textField: 'cn',
        valueField: 'Id',
        service: this.designerService,
      },
      {
        type: 'multiselect',
        title: 'Program Notification Users',
        name: 'ProgramNotificationUsers',
        textField: 'PnuName',
        valueField: 'Id',
        service: this.programNotificationUsers,
        stretch: true,
      },
    ];

    return [{
      title: "Part",
      selected: true,
      formControls
    }]
  }


  columns: any[] = [
    {
      field: 'PartNumber',
      title: 'Part Number',
    },
    {
      field: 'ProcessName',
      title: 'Process',
      width: 140
    },
    {
      field: 'DesignPhase',
      title: 'Design Phase',
    },
    {
      field: 'ProgramName',
      title: 'Program',
    },
    {
      field: 'Location',
      title: 'Location',
      width: 140
    },
    {
      field: 'PartType',
      title: 'Part Type',
      width: 140
    },
    {
      field: 'PartFamily',
      title: 'Part Family',
    },
    {
      field: 'PTE1UserName',
      title: 'PTE1'
    },
    {
      field: 'PTE2UserName',
      title: 'PTE2',
      visible: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'Designer',
      title: 'Designer',
      visible: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'TM',
      title: 'TM',
      visible: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'ProgramNotificationUserNames',
      title: 'Program Notification Users',
      visible: false,
      sortable: true,
      filterable: true
    }
  ]

  customToolBarButtons = [
    {
      text: 'Manage PTE Ownership',
      title: 'Manage Program Tool Engineer Ownership',
      iconClass: 'fa fa-pencil fa-fw',
      callback: () => this.isShowPartOwnership = true
    } as GridButton
  ]
}

